export const zh = {
  // Meta Tags
  meta: {
    title: '青岛思提尔检测技术服务 ISO 17025 检测实验室',
    description: 'ILAC认可国际公认检测机构。专业从事时尚珠宝、婴幼儿用品及一般商品的欧洲·美国有害物质法规检测分析。拥有ISO/IEC 17025认证。提供有害物质检测、儿童用品安全性检测、适用性评价服务。',
    keywords: '检测机构, 有害物质检测, 儿童用品安全性, ISO 17025, ILAC认可, 时尚珠宝分析',
    ogTitle: 'ISO 17025 检测实验室 - 国际公认检测机构',
    ogDescription: 'ILAC认可国际公认检测机构。有害物质检测分析专业'
  },

  // Navigation
  nav: {
    home: '首页',
    about: '关于我们',
    services: '服务项目',
    certifications: '认证资质',
    equipment: '设备介绍',
    virtualTour: '虚拟参观',
    resources: '资料中心',
    contact: '联系我们',
    business: '主要业务',
    testingAnalysis: '试验/分析',
    productTesting: '产品试验评价',
    certificationMark: '认证业务/认证标志',
    customerSupport: '客户·技术支援',
    industrySolutions: '行业解决方案',
    certificationSupport: '认证制度支持(按领域)',
    technicalCenter: '技术中心(附属)',
    jewelry: '珠宝',
    childrenBaby: '儿童婴幼儿用品',
    educationCenter: '教育中心',
    regulationResearch: '法规研究/标准开发',
    equipmentCertifications: '设备/资质',
    announcements: '公告',
    location: '访问路线',
    ceoMessage: 'CEO致辞',
    managementPolicy: '经营方针',
    companyInfo: '公司介绍',
    companyHistory: '公司历史',
    organization: '组织架构'
  },

  // Hero Section
  hero: {
    badge: 'ISO/IEC 17025 认证',
    
    // Slide titles
    slide1Title: '先进化学分析',
    slide2Title: '综合产品安全测试',
    slide3Title: '研发支持',
    slide4Title: '环境认证及碳足迹',

    // Slide 1
    slide1MainTitle: 'ISO/IEC 17025 认证第三方公认检测机构',
    slide1Point1: '基于准确的分析数据',
    slide1Point1Text: '基于准确的分析数据',
    slide1Point2: '提供高可信度的检测报告和证书。',
    slide1Point2Text: '提供高可信度的检测报告和证书。',

    // Slide 2
    slide2MainTitle: '最高水平的技术标准和专业工程师',
    slide2Point1: '考虑安全/卫生环境的严格产品认证规格',
    slide2Point1Text: '考虑安全/卫生环境的严格产品认证规格',
    slide2Point2: '通过长期经验积累的专业评估服务',
    slide2Point2Text: '通过长期经验积累的专业评估服务',
    slide2Point3: '客户和市场信赖的检测认证专业机构',
    slide2Point3Text: '客户和市场信赖的检测认证专业机构',

    // Slide 3
    slide3MainTitle: '研发与技术服务',
    slide3Point1: '针对不良问题的技术分析与解决方案',
    slide3Point1Text: '针对不良问题的技术分析与解决方案',
    slide3Point2: '从材料选择到成品的全流程支持',
    slide3Point2Text: '从材料选择到成品的全流程支持',
    slide3Point3: '深受客户与市场信赖的检测与认证专业机构',
    slide3Point3Text: '深受客户与市场信赖的检测与认证专业机构',

    // Slide 4
    slide4MainTitle: '环境认证与可持续发展',
    slide4Point1: '碳足迹评估',
    slide4Point1Text: '提供综合碳足迹评估',
    slide4Point2: '环境影响评估',
    slide4Point2Text: '提供详细的环境影响评估服务',
    slide4Point3: '可持续发展目标: ',
    slide4Point3Text: '可持续发展目标: 支持企业实现可持续发展目标并遵守国际环境标准。',

    // Products
    product1: '珠宝/时尚配饰',
    product2: '玩具/婴儿用品',
    product3: '婴儿服装',
    product4: '耳环',
    product5: '婴儿枕头',
    product6: '乐高Spike',
    product7: '老年防护设备',
    product8: '金手镯',
    product9: '自行车头盔',
    product10: '齿轮',
    product11: '文具',
    product12: '纤维/皮革产品',
    product13: '家具/室内装饰',
    product14: '餐具/食品容器',
    product15: '包装/运输',
    product16: '检查/现场测试',

    // Equipment
    equipment1Name: 'GC-MS',
    equipment1Desc: 'Agilent Technologies的气相色谱-质谱联用仪。用于有机化合物分析及微量成分检测。',
    equipment1App1: '有机化合物分析',
    equipment1App2: '挥发性物质检测',
    equipment1App3: '环境污染物分析',
    equipment2Name: '设备 2',
    equipment2Desc: '第二个设备的说明。上传照片后将更新为实际设备信息。',
    equipment2App1: '应用领域 1',
    equipment2App2: '应用领域 2',
    equipment2App3: '应用领域 3',
    equipment3Name: '设备 3',
    equipment3Desc: 'Rayleigh UV-1801紫外/可见分光光度计。用于物质的吸光度测量及浓度分析。',
    equipment3App1: '吸光度测量',
    equipment3App2: '浓度分析',
    equipment3App3: '物质定性/定量分析',
    equipment4Name: '设备 4',
    equipment4Desc: '第四个设备的说明。上传照片后将更新为实际设备信息。',
    equipment5Name: '设备 5',
    equipment5Desc: '第五个设备的说明。上传照片后将更新为实际设备信息。',
    equipment6Name: '设备 6',
    equipment6Desc: '第六个设备的说明。上传照片后将更新为实际设备信息。',
    equipment7Name: '设备 7',
    equipment7Desc: 'ETHOS EASY微波消解系统。用于样品的预处理及消解工作的高级设备。',
    equipment7App1: '样品预处理',
    equipment7App2: '微波消解',
    equipment7App3: '金属分析预处理',
    equipment8Name: '设备 8',
    equipment8Desc: '高温马弗炉(Muffle Furnace)。用于样品的灰化、热处理及高温实验的必需设备。',
    equipment8App1: '样品灰化',
    equipment8App2: '高温热处理',
    equipment8App3: '灰分含量测量',
    equipment9Name: '设备 9',
    equipment9Desc: '第九个设备的说明。上传照片后将更新为实际设备信息。',
    equipment10Name: '设备 10',
    equipment10Desc: '第十个设备的说明。上传照片后将更新为实际设备信息。',
    equipment11Name: '设备 11',
    equipment11Desc: '第十一个设备的说明。上传照片后将更新为实际设备信息。',
    equipment12Name: '设备 12',
    equipment12Desc: '第十二个设备的说明。上传照片后将更新为实际设备信息。',
    equipment13Name: '设备 13',
    equipment13Desc: '第十三个设备的说明。上传照片后将更新为实际设备信息。',
    equipment14Name: '设备 14',
    equipment14Desc: '第十四个设备的说明。上传照片后将更新为实际设备信息。',
    equipment15Name: '设备 15',
    equipment15Desc: 'COX EM-30AX先进分析系统。用于精密分析和测量的高级设备。',
    equipment15App1: '精密分析',
    equipment15App2: '成分测量',
    equipment15App3: '质量管理',
    equipment16Name: '设备 16',
    equipment16Desc: '第十六个设备的说明。上传照片后将更新为实际设备信息。',
    equipment17Name: '设备 17',
    equipment17Desc: '第十七个设备的说明。上传照片后将更新为实际设备信息。',
    equipment18Name: '设备 18',
    equipment18Desc: 'Vision检测系统。用于产品外观检查及质量管理的精密检测设备。',
    equipment18App1: '外观检查',
    equipment18App2: '质量管理',
    equipment18App3: '缺陷检测',
    equipment19Name: '设备 19',
    equipment19Desc: 'X射线荧光分析仪(XRF)。以非破坏方式分析物质元素组成的精密设备。',
    equipment19App1: '元素分析',
    equipment19App2: '非破坏检测',
    equipment19App3: '金属成分分析',
    equipment20Name: '设备 20',
    equipment20Desc: '第二十个设备的说明。上传照片后将更新为实际设备信息。',
    equipment21Name: '设备 21',
    equipment21Desc: '第二十一个设备的说明。上传照片后将更新为实际设备信息。',

    // Cards
    card1Title: 'ISO 17025 认证',
    card1Desc: '国际公认实验室质量管理体系',
    card2Title: '全球网络',
    card2Desc: 'ILAC MRA 相互认可协议成员',
    card3Title: '先进设备',
    card3Desc: '最新分析设备和专业人员',
    card4Title: '专业团队',
    card4Desc: '经验丰富的专家团队',

    // Buttons
    btnServices: '查看服务',
    btnContact: '联系我们'
  },

  // About Section
  about: {
    badge: '公司介绍',
    title: 'CTL 介绍',
    subtitle: '以信赖和专业性支持客户成功的国际公认检测机构',
    mission: '我们的使命',
    missionDesc: '通过最高水平的检测分析服务，支持客户产品在全球市场安全流通，为保护消费者健康和安全做出贡献。',
    vision: '我们的愿景',
    visionDesc: '成长为亚洲最优秀的检测分析机构，引领全球质量标准，通过持续创新和发展成为行业标杆。',
    values: '核心价值',
    value1: '准确性',
    value1Desc: '通过精密分析和可靠结果赢得客户信赖',
    value2: '专业性',
    value2Desc: '基于丰富经验和专业知识提供最佳服务',
    value3: '快速性',
    value3Desc: '通过快速检测处理和报告发行节省客户时间',
    value4: '客户至上',
    value4Desc: '以客户满意为最优先，提供持续支持'
  },

  // History Section
  history: {
    badge: '公司历史',
    title: '我们的成长历程',
    subtitle: '介绍CTL的发展历程和主要成就',
    year2026: '2026年 ~',
    event2026_1: '设立 CTL 韩国分公司及越南试验所（进行中）',
    year2018: '2018年 ~',
    event2018_1: 'ISO/IEC 17025 认可试验机构第4次扩大认可项目',
    event2018_2: '检测领域扩展至有害物质分析及全品类生活消费品',
    year2017: '2017年 ~',
    event2017_1: '获得 ISO/IEC 17025 认可试验机构资格【ILAC / CNAS】',
    event2017_2: '为 1,200 家出口企业及 30 余家全球买家提供认可检测服务',
    year2016: '2016年 ~',
    event2016_1: '与韩国珠宝共同研究院签署联合研究开发合作协议（表面处理及相关技术领域）',
    year2014: '2014年 ~',
    event2014_1: '与中韩工艺品协会签署合作备忘录（MOU）',
    year2012: '2012年 ~',
    event2012_1: '设立第三方独立法人试验所（中国青岛、香港）',
    year2008: '2008年 ~',
    event2008_1: '支持企业内部第二方试验所建设',
    event2008_2: '运营中央试验所（Central Testing Lab），提供企业自有试验所技术指导',
    year2007: '2007年 ~',
    event2007_1: '为应对美国 CPSIA 及欧盟 REACH 法规构建 HSPM 有害物质管理系统',
    event2007_2: '向出口企业及国际买家提供法规与技术支持'
  },

  // Services Section（综合检测解决方案 - 图片内容同步为页面文案）
  services: {
    badge: '服务',
    title: '综合检测解决方案',
    subtitle: '涵盖化学分析、物理特性、产品安全的专业检测服务',

    service1Title: '化学检测',
    service1Item1: '有害物质分析',
    service1Item2: '金属/非金属/材料分析',
    service1Item3: '高分子/纤维分析',
    service1Item4: '玩具等消费品卫生试验',
    service1Item5: '贵金属・珠宝产品试验分析',

    service2Title: '物理检测',
    service2Item1: '消费品安全评价试验',
    service2Item2: '可靠性试验',
    service2Item3: '表面处理耐久性评价试验',
    service2Item4: '纺织材料及电气材料的阻燃性试验',
    service2Item5: '环境疲劳试验',

    service3Title: '产品安全',
    service3Item1: '贵金属・珠宝产品安全品质评价',
    service3Item2: '玩具等消费品安全性评价',
    service3Item3: '家用电器产品安全性评价',
    service3Item4: '国内外认证相关产品评价',
    service3Item5: '完整包装(内外)产品评价',

    service4Title: 'System认证及认证标志',
    service4Item1: '贵金属质量认证',
    service4Item2: 'HSPM・有害物质管理',
    service4Item3: 'IATF16949认证咨询',
    service4Item4: 'SAH安全卫生认证',
    service4Item5: '作业场所环境评价',

    service5Title: '研究开发',
    service5Item1: '标准物开发',
    service5Item2: '标准・规格制定',
    service5Item3: '技术书籍发行',

    service6Title: '企业支援',
    service6Item1: '教育・培训',
    service6Item2: '企业实验室支持・中心实验室运营',
    service6Item3: '认证获取咨询'
  },

  // Certifications Section
  certifications: {
    badge: '认证资质',
    title: '国际认证',
    subtitle: '获得主要国际机构认可的检测机构',
    cert1Title: 'ISO/IEC 17025 认证',
    cert1Desc: '保证检测和校准结果准确性和可靠性的国际公认实验室质量管理体系。',
    cert1Tag1: '国际标准',
    cert1Tag2: '质量保证',
    cert1Tag3: '可靠性',
    cert2Title: 'ILAC MRA 认可',
    cert2Desc: '国际实验室认可合作组织相互认可协议，保证检测结果的全球认可。',
    cert2Tag1: '全球认可',
    cert2Tag2: '相互认可',
    cert2Tag3: '国际合作',
    cert3Title: '美国CPSC 认可',
    cert3Desc: '通过了美国CPSC实验室认可',
    cert3Tag1: 'cpsc认可',
    cert3Tag2: 'CPC制作',
    cert3Tag3: '国际合作',
    region1: '欧洲标准',
    region2: '美国标准',
    region3: '亚洲标准',
    region4: '国际标准'
  },

  // Contact Section
  contact: {
    badge: '联系我们',
    title: '联系方式',
    subtitle: '准备开始您的检测项目了吗？请联系我们的专家团队。',
    
    infoTitle: '联系信息',
    phone: '电话',
    email: '邮箱',
    address: '地址',
    addressLine1: '',
    addressLine2: '青岛市城阳区书云东路57号1号楼301室',
    hours: '营业时间',
    hoursWeekday: '周一至周五: 08:00-18:00',
    hoursWeekend: '周六: 08:00-14:00',
    
    quickTitle: '快速咨询',
    quickDesc: '有紧急咨询事项吗？请直接电话咨询。',
    quickPhone: '咨询电话',
    
    formTitle: '咨询表单',
    formName: '姓名',
    formCompany: '公司名称',
    formEmail: '邮箱',
    formPhone: '电话号码',
    formService: '服务类型',
    formServicePlaceholder: '请选择服务',
    formServiceOption1: '化学分析',
    formServiceOption2: '物理检测',
    formServiceOption3: '产品安全',
    formServiceOption4: '环境检测',
    formServiceOption5: '纺织检测',
    formServiceOption6: '食品安全',
    formServiceOption7: '其他',
    formMessage: '咨询内容',
    formMessagePlaceholder: '请输入您的咨询内容（最多500字）',
    formSubmit: '提交咨询',
    formSuccess: '咨询已成功提交！',
    formError: '提交咨询时发生错误，请重试。'
  },

  // Equipment Section
  equipment: {
    badge: '设备',
    title: '检测设备',
    subtitle: '配备最先进的分析设备和专业人员，提供准确可靠的检测结果',
    applicationsLabel: '主要应用领域:'
  },

  // Announcements Page
  announcements: {
    badge: '公告',
    title: '公告',
    subtitle: '暂无公告内容',
    backToHome: '返回首页',
    emptyTitle: '暂无公告',
    emptyDesc: '目前没有公告内容，请稍后再来查看。'
  },

  // Location Section
  location: {
    badge: '访问路线',
    title: '来访路线',
    subtitle: '交通便利，方便您的来访',
    subway: '地铁',
    subwayLine: '青岛地铁1号线',
    subwayDesc: '高新区站下车后步行5分钟',
    subwayMapLink: '点击查看青岛地铁线路图',
    car: '自驾',
    carParking: '免费停车',
    carDesc: '',
    bus: '公交',
    busLines: '111、131、946、4201号',
    busDesc: '太平庄站下车，往西900米'
  },

  // Footer
  footer: {
    description: '作为ISO/IEC 17025认证的国际公认检测机构，提供最高水平的检测分析服务。',
    servicesTitle: '服务',
    service1: '化学分析',
    service2: '物理检测',
    service3: '产品安全',
    service4: '环境检测',
    quickLinksTitle: '快速链接',
    contactTitle: '联系方式',
    copyright: '© 2024 青岛思提尔检测实验室. 版权所有.',
    poweredBy: '网站建设'
  },

  // Company submenu
  company: {
    info: '公司介绍',
    ceoMessage: 'CEO致辞',
    history: '公司历史'
  },

  // Company Info Page
  companyInfo: {
    badge: 'Company Info',
    title: '公司介绍',
    subtitle: '以信赖和专业性支持客户成功的国际认证实验室',
    
    mainTitle: 'CTL（青岛思提尔检测技术服务有限公司）',
    paragraph1: 'CTL于2012年正式成立，2017年获得CNAS及ILAC国际认证，是一家专业的检测检验机构。',
    paragraph2: 'CTL提供仿真饰品、玩具、电子电气产品、纺织品、皮革等多种消费品领域的检测检验服务，建立了覆盖欧洲、美国、日本、韩国、中国等全球的服务网络。此外，通过与中国主要电子商务平台的战略合作，为提升整个行业的质量竞争力做出贡献。',
    paragraph3: '基于国际水平的先进检测设备和熟练的专业技术人员，CTL在科学公正性、准确性、效率性的服务理念下，严格遵守国内外检测规格和法规。',
    paragraph4: '不仅为客户提供可靠的检测检验报告，还通过对各国安全环境法规要求的检测分析和技术支持，支持全球市场进入和顺畅的产品流通。',
    paragraph5: 'CTL致力于成为企业材料开发和质量管理全过程中共同成长的核心合作伙伴。',
    
    tag1: 'CNAS认证',
    tag2: 'ILAC MRA成员',
    tag3: '国际认证',
    
    missionTitle: '我们的使命',
    missionDesc: '通过最高水平的检测分析服务，支持客户产品在全球市场安全流通，为保护消费者健康和安全做出贡献。',
    
    visionTitle: '我们的愿景',
    visionDesc: '成长为亚洲最优秀的检测分析机构，引领全球质量标准，通过持续创新和发展成为行业标杆。',
    
    valuesTitle: '核心价值',
    value1Title: '准确性',
    value1Desc: '通过精密分析和可靠结果赢得客户信赖',
    value2Title: '专业性',
    value2Desc: '基于丰富经验和专业知识提供最佳服务',
    value3Title: '快速性',
    value3Desc: '通过快速检测处理和报告发行节省客户时间',
    value4Title: '客户至上',
    value4Desc: '以客户满意为最优先，提供持续支持',
    companyName: '青岛思提尔检测技术服务有限公司',
    
    stat1: '2015',
    stat1Label: '成立年份',
    stat2: '50+',
    stat2Label: '专业人员',
    stat3: '10,000+',
    stat3Label: '年度检测数',
    stat4: '30+',
    stat4Label: '合作国家',
    
    ctaTitle: '需要更详细的信息吗？',
    ctaDesc: '专业顾问将快速审查贵公司的需求并提供最佳解决方案',
    contactButton: '联系我们',
    servicesButton: '查看服务'
  },

  // CEO Message Page
  ceoMessage: {
    badge: 'CEO Message',
    title: 'CTL 致辞',
    subtitle: '创造全球信赖的检测标准',
    greeting: 'CTL 是依据 ISO/IEC 17025 国际标准运行的公认检测与分析机构，并获得 CNAS 认可及 ILAC MRA 国际互认。',
    paragraph1: '依托国际先进的检测与分析设备以及经验丰富的专业技术团队，CTL 为客户提供准确、可靠的检测与检验服务，其检测结果及报告已在全球主要国家和市场中得到广泛认可。',
    paragraph2: '我们通过高效的检测流程与规范化的报告发布体系，帮助客户节省宝贵时间，并始终坚持以合理的价格提供最高质量的服务。同时，通过持续的技术支持与专业咨询，陪伴客户实现长期稳定的发展。',
    promiseTitle: '核心价值',
    promise1: '科学的公正性',
    promise2: '准确性',
    promise3: '效率性',
    promise4: '积极支持各国安全及环境法规的应对与合规',
    paragraph3: 'CTL 不仅仅是一家提供检测结果的机构，更以成为协助客户产品在全球市场安全、顺利流通的可信赖合作伙伴为目标。我们始终坚信，客户的成功就是我们的成功，并以此信念全力以赴完成每一项工作。',
    paragraph4: '基于对各国商品相关法规的持续研究与专业积累，CTL 以"科学的公正性、准确性和效率性"为核心价值，积极支持各国安全及环境法规的应对与合规。特别是在珠宝、儿童用品及各类消费品领域，CTL 从产品开发阶段开始，直至进入全球市场的安全流通，作为客户的长期全球合作伙伴，持续提供专业支持。',
    paragraph5: '未来，CTL 将通过不断的技术研发与质量创新，成长为立足亚洲、面向世界的领先检测与分析机构。诚挚感谢各位客户一直以来的关注与支持。',
    closing: '谢谢！',
    ceoName: '金在明',
    ceoTitle: '代表理事',
    companyName: 'CTL（青岛 CTL 检测与技术服务有限公司）',
    philosophyTitle: '经营哲学',
    value1Title: '公正性',
    value1Desc: '通过准确公正的检测结果赢得客户信赖',
    value2Title: '准确性',
    value2Desc: '以最优秀的专业人员和设备提供可靠检测与分析',
    value3Title: '效率性',
    value3Desc: '以迅速、规范的服务成为客户成功的合作伙伴',
    ctaTitle: '需要检测分析服务吗？',
    ctaDescription: '专业顾问将快速审查贵公司的需求并提供最佳解决方案',
    contactButton: '联系我们',
    servicesButton: '查看服务',
    backToHome: '返回首页'
  },

  // Management Policy Page
  managementPolicy: {
    badge: 'Management Policy',
    title: '经营方针',
    subtitle: '为客户满意和质量优先的经营哲学和方针',
    
    // Vision
    visionTitle: '经营愿景',
    visionDescription: '作为全球检测认证领域的领先企业，基于最高水平的技术力和可靠性支持客户成功，为产业发展做出贡献。',
    visionPoint1: '遵守国际标准及持续质量改进',
    visionPoint2: '提供以客户为中心的定制服务',
    visionPoint3: '技术创新和专业性强化',
    
    // Mission
    missionTitle: '经营使命',
    missionDescription: '通过准确可靠的检测服务保证产品安全和质量，积极支持客户进入全球市场。',
    missionPoint1: 'ISO/IEC 17025基础检测质量保证',
    missionPoint2: '提供快速准确的检测结果',
    missionPoint3: '专业技术咨询及支持',
    
    // ESH Social Responsibility
    eshTitle: '环境、安全、健康社会责任',
    eshSubtitle: '实践以环境保护、工作场所安全、员工健康为最优先的社会责任经营。',
    
    environmentTitle: '环境保护及可持续性',
    environmentPoint1: '引进环保检测方法及设备',
    environmentPoint2: '化学物质及废弃物最小化',
    environmentPoint3: '能源效率化及碳排放减少',
    environmentPoint4: '遵守ISO 14001环境管理体系',
    
    safetyTitle: '工作场所安全管理',
    safetyPoint1: '定期安全教育及培训',
    safetyPoint2: '个人防护装备提供及管理',
    safetyPoint3: '遵守危险物质处理安全程序',
    safetyPoint4: '事故预防系统及紧急应对体系',
    
    healthTitle: '员工健康促进',
    healthPoint1: '定期健康检查及特殊健康检查',
    healthPoint2: '工作环境测量及改善',
    healthPoint3: '肌肉骨骼疾病预防项目',
    healthPoint4: '员工福利及健康促进项目',
    
    // Core Management Policies
    corePoliciesTitle: '核心经营方针',
    corePoliciesSubtitle: '遵守ISO/IEC 17025国际标准，通过持续质量改进提供最高水平的检测服务。',
    
    qualityFirstTitle: '质量优先',
    qualityFirstDesc: '遵守ISO/IEC 17025国际标准，通过持续质量改进提供最高水平的检测服务。',
    
    customerSatisfactionTitle: '客户满意',
    customerSatisfactionDesc: '准确把握客户需求，通过快速准确的服务实现客户满意。',
    
    expertiseTitle: '专业性强化',
    expertiseDesc: '通过持续教育和培训培养专业人才，掌握最新技术和知识。',
    
    environmentalTitle: '环境责任',
    environmentalDesc: '引进环保检测方法，为可持续发展而努力。',
    
    innovationTitle: '技术创新',
    innovationDesc: '通过引进尖端设备和技术持续提升检测能力。',
    
    globalCooperationTitle: '全球合作',
    globalCooperationDesc: '通过ILAC MRA认可发行国际认可的检测报告，构建全球网络。',
    
    // Quality Management System
    qmsTitle: '质量管理体系',
    qmsSubtitle: '运营基于ISO/IEC 17025的系统化质量管理体系，保证检测的准确性和可靠性。',
    
    documentManagementTitle: '文档管理',
    documentManagementDesc: '系统化文档管理体系',
    
    personnelManagementTitle: '人员管理',
    personnelManagementDesc: '专业人员教育及资格管理',
    
    equipmentManagementTitle: '设备管理',
    equipmentManagementDesc: '定期校准及维护保养',
    
    dataManagementTitle: '数据管理',
    dataManagementDesc: '准确的数据记录及分析'
  },

  // Common
  common: {
    loading: '加载中...',
    error: '发生错误',
    success: '成功',
    readMore: '阅读更多',
    learnMore: '了解更多',
    getStarted: '开始',
    contactUs: '联系我们',
    viewAll: '查看全部',
    backToHome: '返回首页'
  },

  // Business Page
  business: {
    badge: '主要业务',
    title: '主要业务',
    subtitle: '介绍CTL的多种业务领域。',
    backToHome: '返回首页',
    laboratoryName: 'ISO 17025 检测实验室',
    laboratoryDesc: 'ILAC 认可检测服务',
    col1Header: '试验分析',
    col2Header: '产品适合性评价',
    col3Header: '产品检查',
    col4Header: 'System认证及认证标志',
    col5Header: '研究开发',
    col6Header: '企业支援',
    ctaTitle: '主要业务咨询',
    ctaDesc: '专业顾问将快速审查您的需求并提出最佳解决方案。',
    ctaPhone: '客户服务电话',
    tableData: [
      { rowHeader: '材料/原材料分析', col1: ['时尚·珠宝产品'], col2: ['产品质量检查'], col3: ['SA-8000'], col4: ['标准物开发'], col5: ['教育·培训'] },
      { rowHeader: '有害物质分析', col1: ['玩具、婴幼儿用品、文具'], col2: ['工厂审核'], col3: ['HSPM'], col4: ['标准·规格制定'], col5: ['咨询支援'] },
      { rowHeader: '高分子材料', col1: ['卫生用品'], col2: ['On-site试验检查'], col3: ['ISO9000/140000'], col4: ['技术书籍发行'], col5: [] },
      { rowHeader: '贵金属材料分析', col1: ['纺织品'], col2: [], col3: ['IATF-16949认证咨询'], col4: [], col5: [] },
      { rowHeader: '金属/非金属/矿物', col1: ['老年人安全产品'], col2: [], col3: ['SAH安全卫生认证'], col4: [], col5: [] },
      { rowHeader: '表面处理/镀液分析', col1: ['环境/安全/保健产品'], col2: [], col3: ['贵金属质量认证'], col4: [], col5: [] },
      { rowHeader: '纤维材料及物性试验', col1: ['汽车电子电气部件试验'], col2: [], col3: ['作业场所环境评价'], col4: [], col5: [] },
      { rowHeader: '物理强度及疲劳试验', col1: ['家用电器产品'], col2: [], col3: [], col4: [], col5: [] },
      { rowHeader: '可靠性试验', col1: ['完整包装(内外)产品评价'], col2: [], col3: [], col4: [], col5: [] },
      { rowHeader: '生活消费品相关试验', col1: ['国内外认证相关产品评价'], col2: [], col3: [], col4: [], col5: [] },
      { rowHeader: '环境卫生相关试验分析', col1: ['产品不良原因分析评价'], col2: [], col3: [], col4: [], col5: [] },
      { rowHeader: '包装材料试验', col1: [], col2: [], col3: [], col4: [], col5: [] },
      { rowHeader: '电子组件试验', col1: [], col2: [], col3: [], col4: [], col5: [] },
      { rowHeader: '微生物试验', col1: [], col2: [], col3: [], col4: [], col5: [] }
    ]
  },

  // Testing Analysis Page
  testingAnalysis: {
    badge: '主要业务',
    title: '试验/分析项目',
    subtitle: '在ISO 17025认证的实验室提供准确可靠的试验分析服务。',
    backToHome: '首页',
    laboratoryName: 'ISO 17025 检测实验室',
    laboratoryDesc: 'ILAC 认可检测服务',
    
    category1Title: '材料/原材料分析',
    category1Items: ['金属/非金属', '矿物质', '高分子材料', '玻璃/陶瓷材料', '贵金属分析'],
    
    category2Title: '有害物质分析',
    category2Items: [
      '重金属', '邻苯二甲酸酯', 'pH值', '甲醛', '多环芳烃', 
      '偶氮染料', 'APEOs', '富马酸二甲酯 (DMFu或DMF)', '双酚A',
      '致癌染料', '六价铬', '五氯苯酚', '四氯苯酚', '分散染料', 
      '阻燃剂', '镍释放', '亚硝胺', 
      '有机锡', '全氟化合物', '溶剂'
    ],
    
    category3Title: '表面处理/镀液试验',
    category3Items: ['金/银', '贵金属含量', '镀液分析'],
    
    category4Title: '物理试验',
    category4Items: ['拉伸强度', '硬度(HV)', '耐久性试验'],
    
    category5Title: '纺织试验',
    category5Items: ['阻燃性试验', '30多种水洗试验', '材料识别'],
    
    category6Title: '可靠性试验',
    category6Items: ['盐雾试验', '环境老化试验', '耐磨试验', '光照试验'],
    
    category7Title: '包装试验',
    category7Items: ['运输试验', '跌落试验', '爆破/边压试验'],
    
    ctaTitle: '试验分析咨询',
    ctaDesc: '专业顾问将详细指导您的试验分析需求。',
    ctaPhone: '客户服务电话'
  },

  // Certifications Page
  certificationsPage: {
    badge: 'Certifications',
    title: '认证现状',
    subtitle: '国际认可的实验室认证及资质现状',
    backToHome: '首页',
    
    iso17025Title: 'ISO/IEC 17025',
    iso17025Desc: '获得了试验和校准实验室能力的国际标准认证，试验结果的准确性和可靠性得到国际保证。',
    iso17025Tag1: '国际标准',
    iso17025Tag2: '质量保证',
    iso17025Tag3: '技术能力',
    
    ilacTitle: 'ILAC MRA',
    ilacDesc: '加入国际实验室认可合作组织(ILAC)相互认可协议，发行的试验报告在全球范围内获得认可。',
    ilacTag1: '全球认可',
    ilacTag2: '相互认可',
    ilacTag3: '国际合作',
    
    regionalTitle: '地区认证现状',
    region1: 'European Regulations',
    region1Standards: ['REACH/UK REACH', 'ROHS/LVD Directives', 'GDPR/GPSR', 'Toy Safety Directives'],
    region2: 'USA Regulations',
    region2Standards: ['16 CFR CPSC/CPSIA', 'California & other State Law', '21CFR/29CFR', 'CPC/GPSC'],
    region3: 'Asia Regulations',
    region3Standards: ['GB & CCC', 'KS & KC/K-REACH', 'JIS & PSE/PSC', 'ASEAN Harmonized Standard'],
    region4: 'International Harmonized Regulations',
    region4Standards: ['IECEE CB Scheme', 'ISO/IEC', 'GHS', 'Codex Alimentarius'],
    
    certDetailsTitle: '认证详情',
    chemicalCertTitle: '化学试验认证',
    chemicalCertItems: ['ICP-MS分析', 'GC-MS分析', 'LC-MS/MS分析', 'XRF分析'],
    
    physicalCertTitle: '物理试验认证',
    physicalCertItems: ['机械特性', '热分析', '电气试验', '尺寸测量'],
    
    safetyCertTitle: '产品安全认证',
    safetyCertItems: ['玩具安全', '纺织品安全', '电子产品安全', '食品接触材料'],
    
    envCertTitle: '环境试验认证',
    envCertItems: ['RoHS', 'REACH', 'Phthalates', 'VOC'],
    
    microCertTitle: '微生物试验认证',
    microCertItems: ['细菌检测', '霉菌检测', '酵母检测', '病原菌检测'],
    
    preciousCertTitle: '贵金属试验认证',
    preciousCertItems: ['金纯度', '银纯度', '铂金纯度', '钻石鉴定'],
    
    // 实际证书信息
    actualCertsTitle: '持有证书',
    cnasTitle: 'CNAS证书',
    cnasNumber: '证书编号: CNAS L10485',
    
    cpscCertTitle: 'CPSC 认可',
    cpscCertNumber: '会员编号: 1698'
  },

  // Industry Solutions Page
  industrySolutions: {
    badge: '客户支持',
    title: '行业解决方案',
    subtitle: '为各行业领域特点量身定制的专业试验、分析、认证解决方案',
    servicesProvided: '提供服务',
    ctaTitle: '需要定制解决方案吗？',
    ctaDesc: '我们为您的行业领域和产品特性提供最优解决方案',
    ctaButton: '咨询联系',
    jewelry: {
      title: '珠宝行业',
      description: '贵金属及宝石类产品质量保证和安全性确保的综合解决方案',
      service1: '贵金属纯度分析（金、银、铂等）',
      service2: '宝石鉴定及质量评估',
      service3: '有害物质检测（镍、镉、铅等）',
      service4: '物理安全性试验',
      service5: '国际认证支持（REACH、RoHS）'
    },
    children: {
      title: '儿童/婴幼儿用品行业',
      description: '以儿童和婴幼儿安全为最优先的专业试验及认证解决方案',
      service1: '物理安全性试验（锐利边缘、小部件）',
      service2: '化学安全性试验（邻苯二甲酸酯、重金属）',
      service3: '可燃性试验',
      service4: 'EN 71、ASTM F963、CPSIA认证支持',
      service5: '产品改进咨询'
    },
    textile: {
      title: '纺织/服装行业',
      description: '保证纺织产品质量和安全性的专业试验服务',
      service1: '纤维成分分析',
      service2: '染色牢度试验',
      service3: '有害物质检测（偶氮染料、甲醛）',
      service4: '物理性能试验（强度、耐久性）',
      service5: 'Oeko-Tex Standard 100认证支持'
    },
    cosmetics: {
      title: '化妆品行业',
      description: '验证化妆品安全性和功效的专业分析服务',
      service1: '微生物试验（总菌数、大肠杆菌、绿脓杆菌）',
      service2: '重金属分析（铅、砷、汞）',
      service3: '防腐剂及保存剂分析',
      service4: '皮肤刺激试验',
      service5: 'ISO 22716（GMP）认证支持'
    },
    food: {
      title: '食品行业',
      description: '保证食品安全性和质量的综合分析服务',
      service1: '营养成分分析',
      service2: '微生物检测',
      service3: '农药残留检测',
      service4: '重金属分析',
      service5: 'HACCP、ISO 22000认证支持'
    },
    electronics: {
      title: '电子/电气行业',
      description: '验证电子产品安全性和性能的专业试验服务',
      service1: '电气安全性试验',
      service2: '有害物质检测（RoHS、REACH）',
      service3: 'EMC试验（电磁兼容性）',
      service4: '电池安全性试验',
      service5: 'CE、FCC认证支持'
    },
    packaging: {
      title: '包装材料行业',
      description: '验证包装材料安全性和环保性的专业服务',
      service1: '食品接触材料试验',
      service2: '重金属溶出试验',
      service3: '物理性能试验',
      service4: '生物降解性试验',
      service5: 'FDA、EU法规符合性评估'
    },
    medical: {
      title: '医疗器械行业',
      description: '验证医疗器械安全性和功效的专业试验服务',
      service1: '生物相容性试验',
      service2: '灭菌验证',
      service3: '物理/机械性能试验',
      service4: '电气安全性试验',
      service5: 'ISO 13485、CE认证支持'
    }
  },

  // Jewelry Technical Center Page
  jewelryCenter: {
    badge: '技术中心（附属）',
    title: '珠宝技术中心',
    subtitle: '贵金属及宝石类产品质量保证和安全性确保的专业技术支持中心',
    servicesTitle: '专业试验服务',
    servicesSubtitle: '珠宝行业专业的综合试验及分析服务',
    equipmentTitle: '专业设备',
    equipmentSubtitle: '以尖端分析设备提供准确的试验结果',
    ctaTitle: '需要珠宝试验吗？',
    ctaDesc: '专业技术团队为您的产品提供最优化的试验解决方案',
    ctaButton: '咨询联系',
    service1: {
      title: '贵金属纯度分析',
      description: '金、银、铂等贵金属的精确纯度测量',
      item1: '金纯度分析（K单位）',
      item2: '银纯度分析',
      item3: '铂纯度分析',
      item4: '合金成分分析'
    },
    service2: {
      title: '宝石鉴定',
      description: '钻石及各种宝石的质量评估',
      item1: '钻石4C评估',
      item2: '彩色宝石鉴定',
      item3: '珍珠质量评估',
      item4: '合成石鉴别'
    },
    service3: {
      title: '有害物质检测',
      description: '对人体有害物质含量测量',
      item1: '镍释放试验',
      item2: '镉检测',
      item3: '铅含量分析',
      item4: '铬检测'
    },
    service4: {
      title: '物理安全性试验',
      description: '产品耐久性及安全性评估',
      item1: '锐利边缘检查',
      item2: '小部件试验',
      item3: '拉伸强度试验',
      item4: '耐磨性试验'
    },
    service5: {
      title: '国际认证支持',
      description: '出口认证获取支持',
      item1: 'REACH认证',
      item2: 'RoHS认证',
      item3: 'California Prop 65',
      item4: 'KC认证'
    },
    service6: {
      title: '质量保证书发放',
      description: '提供权威质量保证书',
      item1: '纯度保证书',
      item2: '鉴定书',
      item3: '试验报告',
      item4: '符合性证书'
    },
    equipment: {
      icpms: '微量元素分析',
      xrf: '无损成分分析',
      uvvis: '宝石光谱分析',
      scale: '电子天平',
      scaleDesc: '精密重量测量',
      hardness: '硬度计',
      hardnessDesc: '宝石硬度测量',
      microscope: '显微镜',
      microscopeDesc: '微观结构观察',
      refractometer: '折射仪',
      refractometerDesc: '宝石折射率测量',
      spectrometer: '光谱仪',
      spectrometerDesc: '颜色分析'
    }
  },

  // Children Baby Technical Center Page
  childrenCenter: {
    badge: '技术中心（附属）',
    title: '儿童婴幼儿用品技术中心',
    subtitle: '以儿童和婴幼儿安全为最优先的专业试验及技术支持中心',
    servicesTitle: '专业试验服务',
    servicesSubtitle: '儿童/婴幼儿用品安全性评估的综合试验服务',
    productsTitle: '试验对象产品',
    productsSubtitle: '各种儿童/婴幼儿用品的专业试验服务',
    standardsTitle: '适用标准',
    standardsSubtitle: '遵守国内外主要安全标准',
    ctaTitle: '需要儿童/婴幼儿用品试验吗？',
    ctaDesc: '我们为儿童安全提供专业的试验服务',
    ctaButton: '咨询联系',
    service1: {
      title: '物理安全性试验',
      description: '产品物理危险因素评估',
      item1: '锐利边缘检查',
      item2: '小部件试验',
      item3: '拉伸强度试验',
      item4: '压缩试验'
    },
    service2: {
      title: '化学安全性试验',
      description: '有害化学物质含量测量',
      item1: '邻苯二甲酸酯检测',
      item2: '重金属分析',
      item3: 'BPA检测',
      item4: '甲醛测量'
    },
    service3: {
      title: '可燃性试验',
      description: '产品火灾安全性评估',
      item1: '纺织品可燃性试验',
      item2: '塑料可燃性试验',
      item3: '玩具可燃性试验',
      item4: '阻燃性评估'
    },
    service4: {
      title: '微生物试验',
      description: '卫生及微生物安全性评估',
      item1: '总菌数测量',
      item2: '大肠杆菌检测',
      item3: '霉菌检测',
      item4: '沙门氏菌检测'
    },
    service5: {
      title: '国际认证支持',
      description: '国内外安全认证获取支持',
      item1: 'KC认证',
      item2: 'EN 71',
      item3: 'ASTM F963',
      item4: 'CPSIA'
    },
    service6: {
      title: '产品改进咨询',
      description: '安全性提升的专业咨询',
      item1: '设计改进建议',
      item2: '材料选择咨询',
      item3: '标准符合性审查',
      item4: '售后管理支持'
    },
    product1: '玩具',
    product2: '婴儿服装',
    product3: '婴儿车',
    product4: '汽车座椅',
    product5: '奶瓶/奶嘴',
    product6: '尿布',
    product7: '寝具',
    product8: '学习用品',
    product9: '游乐设施',
    product10: '安全用品',
    product11: '餐具',
    product12: '洗浴用品',
    region: {
      korea: '韩国',
      europe: '欧洲',
      usa: '美国',
      china: '中国',
      international: '国际',
      japan: '日本',
      taiwan: '台湾'
    },
    standard1: '儿童产品安全特别法',
    standard2: '玩具安全标准',
    standard3: '玩具安全标准',
    standard4: '消费品安全改进法',
    standard5: '玩具安全技术规范',
    standard6: '玩具安全国际标准',
    standard7: '日本工业标准',
    standard8: '中华民国国家标准'
  },

  // Education Center Page
  educationCenter: {
    badge: '客户支持',
    title: '教育中心',
    subtitle: '为培养产品安全及质量管理专家的系统化教育项目',
    programsTitle: '教育项目',
    programsSubtitle: '以实务为中心的专业教育课程',
    benefitsTitle: '教育福利',
    benefitsSubtitle: '专业性提升和职业发展的各种福利',
    mainContent: '主要内容',
    ctaTitle: '教育申请咨询',
    ctaDesc: '我们提供符合贵公司教育需求的定制教育项目',
    ctaButton: '申请教育',
    level: {
      beginner: '初级',
      intermediate: '中级',
      advanced: '高级'
    },
    program1: {
      title: '质量管理基础课程',
      duration: '2天（16小时）',
      description: '质量管理的基本概念和实务应用方法',
      topic1: '质量管理概论',
      topic2: '统计质量管理',
      topic3: '检验及试验方法',
      topic4: '不良分析技法'
    },
    program2: {
      title: '产品安全标准课程',
      duration: '3天（24小时）',
      description: '国内外产品安全标准的理解和应用',
      topic1: 'KC认证制度',
      topic2: 'EN 71标准',
      topic3: 'ASTM标准',
      topic4: 'CPSIA规定'
    },
    program3: {
      title: '化学试验分析课程',
      duration: '5天（40小时）',
      description: '化学试验方法及分析技术习得',
      topic1: 'ICP-MS分析',
      topic2: 'GC-MS分析',
      topic3: 'HPLC分析',
      topic4: '样品前处理'
    },
    program4: {
      title: '物理试验评估课程',
      duration: '3天（24小时）',
      description: '物理试验方法及评估技术',
      topic1: '机械试验',
      topic2: '可燃性试验',
      topic3: '耐久性试验',
      topic4: '环境试验'
    },
    program5: {
      title: 'ISO 17025审核员课程',
      duration: '5天（40小时）',
      description: '实验室认可制度及审核技法',
      topic1: 'ISO 17025要求事项',
      topic2: '内部审核技法',
      topic3: '纠正措施',
      topic4: '文件管理'
    },
    program6: {
      title: '试验报告编写课程',
      duration: '2天（16小时）',
      description: '专业试验报告编写方法',
      topic1: '报告结构',
      topic2: '数据分析',
      topic3: '结果解释',
      topic4: '不确定度评估'
    },
    benefit1: {
      title: '结业证书发放',
      desc: '提供认可的教育结业证书'
    },
    benefit2: {
      title: '专家授课',
      desc: '现场经验丰富的专家授课'
    },
    benefit3: {
      title: '教育资料',
      desc: '提供可用于实务的教育资料'
    },
    benefit4: {
      title: '后续支持',
      desc: '教育后持续的技术支持'
    }
  },

  // Regulation Research Page
  regulationResearch: {
    badge: '客户支持',
    title: '法规研究/标准开发',
    subtitle: '通过国内外法规研究及产业标准开发支持企业竞争力强化',
    servicesTitle: '主要服务',
    servicesSubtitle: '法规研究及标准开发专业服务',
    areasTitle: '研究领域',
    areasSubtitle: '各产业领域的法规及标准研究',
    benefitsTitle: '预期效果',
    benefitsSubtitle: '通过法规研究及标准开发提升企业价值',
    ctaTitle: '法规研究及标准开发咨询',
    ctaDesc: '专家团队支持贵公司的法规应对及标准化战略',
    ctaButton: '咨询联系',
    service1: {
      title: '法规研究及分析',
      description: '国内外产品安全相关法规的系统研究及分析',
      item1: '国内法规监测及分析',
      item2: '海外法规动向调查',
      item3: '法规修订影响评估',
      item4: '法规应对战略制定',
      item5: '法规解释及咨询'
    },
    service2: {
      title: '产业标准开发',
      description: '为产业发展的标准及规格开发',
      item1: 'KS标准开发支持',
      item2: '团体标准制定',
      item3: '试验方法标准化',
      item4: '质量基准设定',
      item5: '标准普及及教育'
    },
    service3: {
      title: '国际标准应对',
      description: '国际标准及规格的专业应对',
      item1: 'ISO/IEC标准研究',
      item2: 'ASTM规格分析',
      item3: 'EN规格应对',
      item4: '国际标准化活动参与',
      item5: '海外认证支持'
    },
    service4: {
      title: '法规符合性评估',
      description: '产品法规及标准符合性综合评估',
      item1: '法规符合性审查',
      item2: '标准遵守与否评估',
      item3: '改进方案提出',
      item4: '认证获取支持',
      item5: '售后管理咨询'
    },
    area1: {
      title: '儿童/婴幼儿用品',
      desc: '玩具及儿童产品安全法规'
    },
    area2: {
      title: '珠宝',
      desc: '贵金属及宝石类质量基准'
    },
    area3: {
      title: '纺织/服装',
      desc: '纺织产品安全及质量标准'
    },
    area4: {
      title: '化妆品',
      desc: '化妆品安全基准及标示规定'
    },
    area5: {
      title: '食品',
      desc: '食品安全管理及标示基准'
    },
    area6: {
      title: '电子/电气',
      desc: '电气用品安全管理规定'
    },
    benefit1: {
      title: '法规风险最小化',
      desc: '预防因法规违反导致的风险'
    },
    benefit2: {
      title: '加速市场进入',
      desc: '通过快速认证获取缩短市场进入时间'
    },
    benefit3: {
      title: '强化竞争力',
      desc: '通过标准引领确保市场竞争力'
    },
    benefit4: {
      title: '支持海外进出',
      desc: '通过国际标准应对扩大出口'
    }
  },

  // Test Guides Page
  testGuides: {
    badge: '试验指南',
    title: '试验指南',
    subtitle: '提供各类试验项目的详细指南和程序。请下载所需资料使用。',
    backToHome: '返回首页',
    companyName: '青岛思提尔检测技术服务有限公司',
    ctaTitle: '需要更多咨询吗？',
    ctaDesc: '如有资料相关咨询或需要更多信息，请随时联系我们。',
    ctaButton: '咨询联系',
    guides: {
      chemical: {
        title: '化学试验指南',
        description: '介绍化学分析试验的整体程序和方法。',
        files: [
          { name: '重金属分析指南.pdf', size: '2.5 MB', date: '2024-01-15' },
          { name: '有害物质检查手册.pdf', size: '3.2 MB', date: '2024-01-10' },
          { name: '化学成分分析程序.pdf', size: '1.8 MB', date: '2024-01-05' }
        ]
      },
      physical: {
        title: '物理试验指南',
        description: '说明物理特性试验的方法和标准。',
        files: [
          { name: '强度试验指南.pdf', size: '2.1 MB', date: '2024-01-20' },
          { name: '耐久性测试手册.pdf', size: '2.8 MB', date: '2024-01-18' },
          { name: '物理特性分析.pdf', size: '1.5 MB', date: '2024-01-12' }
        ]
      },
      quality: {
        title: '质量检查指南',
        description: '介绍产品质量检查的标准和程序。',
        files: [
          { name: '质量管理指南.pdf', size: '3.5 MB', date: '2024-01-25' },
          { name: '检查标准书.pdf', size: '2.2 MB', date: '2024-01-22' },
          { name: '不良判定手册.pdf', size: '1.9 MB', date: '2024-01-15' }
        ]
      },
      environmental: {
        title: '环境试验指南',
        description: '提供环境条件试验的方法和标准。',
        files: [
          { name: '温湿度试验指南.pdf', size: '2.4 MB', date: '2024-01-28' },
          { name: '环境耐久性测试.pdf', size: '3.1 MB', date: '2024-01-24' },
          { name: '气候试验程序.pdf', size: '2.0 MB', date: '2024-01-20' }
        ]
      },
      electrical: {
        title: '电气安全试验指南',
        description: '说明电气安全相关试验的程序和标准。',
        files: [
          { name: '电气安全指南.pdf', size: '2.7 MB', date: '2024-02-01' },
          { name: '绝缘试验手册.pdf', size: '2.3 MB', date: '2024-01-30' },
          { name: '电压测试程序.pdf', size: '1.7 MB', date: '2024-01-28' }
        ]
      },
      sample: {
        title: '样品准备指南',
        description: '介绍试验样品的准备和保管方法。',
        files: [
          { name: '样品采集指南.pdf', size: '2.0 MB', date: '2024-02-03' },
          { name: '样品保管手册.pdf', size: '1.6 MB', date: '2024-02-01' },
          { name: '预处理程序书.pdf', size: '2.2 MB', date: '2024-01-29' }
        ]
      }
    }
  },

  // Certificates Page
  certificates: {
    badge: '证书样本',
    title: '证书样本',
    subtitle: '可查看试验成绩书及各类证书样本。点击图片可放大查看。',
    backToHome: '返回首页',
    companyName: '青岛思提尔检测技术服务有限公司',
    download: '下载',
    issueDate: '签发日期',
    validUntil: '有效期',
    ctaTitle: '证书签发咨询',
    ctaDesc: '如有试验成绩书签发或证书相关咨询，请随时联系我们。',
    ctaButton: '咨询联系',
    certs: {
      iso17025: {
        title: 'ISO/IEC 17025 证书',
        description: '国际公认试验机构证书'
      },
      ilac: {
        title: 'ILAC MRA 认可书',
        description: 'ILAC 相互认可协议认可书'
      },
      testReport: {
        title: '试验成绩书样本',
        description: '化学分析试验成绩书示例'
      },
      qms: {
        title: '质量管理证书',
        description: 'ISO 9001 质量管理体系认证'
      },
      ems: {
        title: '环境管理证书',
        description: 'ISO 14001 环境管理体系认证'
      },
      ohsms: {
        title: '安全健康证书',
        description: 'ISO 45001 安全健康管理体系认证'
      }
    }
  },

  // Hazardous Limits Page
  hazardousLimits: {
    badge: '有害物质限制标准',
    title: '各国有害物质允许标准',
    subtitle: '查看美国、欧洲、德国、中国的主要有害物质限制标准和允许限度。提供各国限制机构和官方来源信息。',
    backToHome: '返回首页',
    companyName: '青岛思提尔检测技术服务有限公司',
    countries: {
      usa: '美国',
      eu: '欧洲',
      germany: '德国',
      china: '中国'
    },
    agenciesTitle: '主要限制机构',
    standardsTitle: '标准',
    substance: '物质名称',
    limit: '允许标准',
    application: '适用对象',
    source: '来源/规定',
    referencesTitle: '官方来源及参考资料',
    noticeTitle: '重要通知',
    noticeItems: [
      '本资料仅供参考，实际试验及认证时请确认最新规定。',
      '限制标准会随时更新，请通过官方来源确认最新信息。',
      '根据产品不同，适用的规定可能不同，请咨询专家。',
      '试验委托前请确认该国家的最新限制要求事项。'
    ],
    ctaTitle: '需要有害物质试验吗？',
    ctaDesc: '我们提供符合各国限制标准的准确试验服务。专业咨询师将为您提供帮助。',
    ctaButton1: '试验咨询',
    ctaButton2: '电话咨询'
  },

  // International Standards Page
  internationalStandards: {
    badge: 'International Standards',
    title: '国际规格及认证',
    subtitle: '按照ISO、IEC、ILAC MRA、OECD GLP等国际认可的标准规格提供试验分析服务',
    backToHome: '返回首页',
    companyName: '青岛思提尔检测技术服务有限公司',
    isoTitle: 'ISO/IEC 17025',
    isoDesc: '国际标准化组织(ISO)和国际电工委员会(IEC)共同制定的试验及校准机构的资格相关国际标准。',
    isoPoints: [
      '试验所的技术能力证明',
      '质量管理体系运营',
      '提供准确可靠的结果',
      '发行国际认可的试验成绩书'
    ],
    isoRequirements: {
      title: 'ISO 17025 主要要求事项',
      management: {
        title: '管理要求事项',
        items: ['组织结构', '文件管理', '内部审查', '纠正措施']
      },
      technical: {
        title: '技术要求事项',
        items: ['人员资格', '设施环境', '试验方法', '设备管理']
      },
      quality: {
        title: '质量保证',
        items: ['结果质量', '数据完整性', '报告发行', '客户满意']
      }
    },
    iecTitle: 'IEC 国际电气标准',
    iecDesc: '遵守国际电工委员会(IEC)制定的电气·电子产品的安全性及性能相关国际标准。',
    iecStandards: [
      { code: 'IEC 60068', name: '环境试验' },
      { code: 'IEC 62368', name: '电气安全' },
      { code: 'IEC 61000', name: 'EMC试验' },
      { code: 'IEC 62133', name: '电池安全' }
    ],
    ilacTitle: 'ILAC 相互认可协议',
    ilacDesc: '通过国际实验室认可合作组织(ILAC)的相互认可协议(MRA)，在全球100多个国家认可试验结果。',
    ilacBenefits: [
      { title: '国际认可', description: '100多个国家认可试验结果' },
      { title: '可靠性保证', description: '按国际标准的品质保证' },
      { title: '防止重复试验', description: '一次试验全球通用' }
    ],
    ilacCountries: 'ILAC MRA 加入国',
    ilacCountriesDesc: '亚洲、欧洲、北美、南美、非洲、大洋洲等全球主要国家都加入了ILAC MRA，相互认可试验结果。',
    oecdTitle: 'OECD 优秀实验室运营标准',
    oecdDesc: '按照经济合作与发展组织(OECD)的Good Laboratory Practice标准进行化学物质安全性试验。',
    oecdItems: [
      { title: '组织及人员', description: '合格的人员和明确的责任体系' },
      { title: '质量保证程序', description: '独立的质量保证体系运营' },
      { title: '设施及设备', description: '适当的设施和验证的设备使用' },
      { title: '试验程序', description: '按标准作业指示书(SOP)进行试验' }
    ],
    benefitsTitle: '国际规格遵守的优点',
    benefitsDesc: '通过国际认可的标准化试验可获得各种好处',
    benefits: [
      { title: '进出口简化', description: '通过国际认可的试验成绩书简化通关程序' },
      { title: '可靠性提高', description: '通过国际标准遵守提高产品可靠性和品牌价值' },
      { title: '成本节约', description: '防止重复试验，节约时间和成本' },
      { title: '市场准入性', description: '满足全球市场进入的必备条件' },
      { title: '法律保护', description: '通过国际规定遵守最小化法律风险' },
      { title: '客户满意', description: '通过可靠的试验结果提高客户满意度' }
    ],
    ctaTitle: '需要国际规格试验吗？',
    ctaDesc: '在ISO 17025认证试验所提供国际认可的试验服务',
    ctaButton1: '咨询联系',
    ctaButton2: '返回首页',
    countries: ['韩国', '美国', '日本', '中国', '德国', '英国', '法国', '加拿大', '澳大利亚', '新加坡']
  },

  // Inquiry Page
  inquiry: {
    badge: '客户支持',
    title: '咨询联系',
    subtitle: '如有试验相关咨询或疑问，请留言，我们会尽快回复。',
    backToHome: '返回首页',
    companyName: 'ISO 17025 Testing Laboratory',
    companySubtitle: 'ILAC Accredited Testing Services',
    tabs: {
      form: '咨询撰写',
      list: '咨询记录'
    },
    formTitle: '咨询撰写',
    formSubtitle: '请详细填写您想咨询的内容',
    successTitle: '咨询已成功受理！',
    successDesc: '我们会尽快回复。',
    fields: {
      name: '姓名',
      nameRequired: '姓名 *',
      company: '公司名称',
      email: '邮箱',
      emailRequired: '邮箱 *',
      phone: '联系方式',
      phoneRequired: '联系方式 *',
      inquiryType: '咨询类型',
      inquiryTypeRequired: '咨询类型 *',
      inquiryTypePlaceholder: '请选择咨询类型',
      message: '咨询内容',
      messageRequired: '咨询内容 *',
      messagePlaceholder: '请详细填写咨询内容（最多500字）',
      submit: '咨询受理'
    },
    inquiryTypes: {
      test: '试验咨询',
      certificate: '证书咨询',
      cost: '费用咨询',
      schedule: '日程咨询',
      technical: '技术咨询',
      other: '其他咨询'
    },
    privacyTitle: '个人信息收集及利用通知',
    privacyDesc: '为处理咨询，将收集姓名、邮箱、联系方式信息，回复完成后保存3个月。',
    listTitle: '咨询记录',
    listSubtitle: '可查看已受理的咨询记录',
    loading: '正在加载咨询记录...',
    emptyTitle: '没有咨询记录',
    emptyDesc: '请撰写第一个咨询！',
    emptyButton: '撰写咨询',
    status: {
      answered: '回复完成',
      pending: '等待回复'
    },
    viewDetails: '点击查看详细内容',
    collapse: '折叠',
    inquiryContent: '咨询内容',
    answerPending: '等待回复中',
    answerPendingDesc: '我们会尽快回复。',
    ctaTitle: '需要紧急咨询吗？',
    ctaDesc: '如有紧急事项，请电话咨询，我们会立即为您提供咨询。',
    ctaPhone: '客户咨询电话',
    ctaPhoneNumber: '0532-55566163/55566165',
    footerEmail: '邮箱',
    footerEmailValue: 'ctl@centrallab.biz'
  },

  // NotFound Page
  notFound: {
    title: 'This page has not been generated',
    subtitle: 'Tell me more about this page, so I can generate it'
  },

  // Product Testing Page
  productTesting: {
    badge: '主要业务',
    title: '产品适合性评价',
    subtitle: '为各种产品群提供专业的试验评价服务。保证按国际规格的准确可靠的试验结果。',
    backToHome: '返回首页',
    companyName: '青岛思提尔检测技术服务有限公司',
    categoriesTitle: '产品类别',
    categoriesSubtitle: '为各产品群提供专业化的试验服务',
    whyTitle: '为什么选择我们？',
    whySubtitle: '基于专业性和可靠性提供最高水平的试验服务',
    processTitle: '试验进行流程',
    processSubtitle: '通过系统化流程提供准确的试验结果',
    ctaTitle: '需要试验咨询吗？',
    ctaDesc: '专业咨询师将为您的产品提供最优化的试验方法指导。',
    ctaButton1: '在线咨询',
    ctaButton2: '电话咨询',
    ctaPhone: '电话咨询',
    ctaPhoneNumber: '0532-55566163/55566165',
    viewTests: '查看试验项目',
    applicableStandards: '适用规格',
    features: [
      { title: 'ISO/IEC 17025 认证', description: '国际认可的公认试验所', icon: 'ri-award-line' },
      { title: '最新试验设备', description: '通过尖端分析设备进行精密试验', icon: 'ri-microscope-line' },
      { title: '专业人员', description: '经验丰富的专业试验人员', icon: 'ri-team-line' },
      { title: '快速处理', description: '快速进行试验并提供结果', icon: 'ri-time-line' }
    ],
    processSteps: [
      { step: '01', title: '咨询受理', description: '确认产品信息及试验要求事项', icon: 'ri-customer-service-line' },
      { step: '02', title: '提供报价', description: '按试验项目提供详细报价指导', icon: 'ri-file-list-line' },
      { step: '03', title: '样品受理', description: '接收样品并准备试验', icon: 'ri-inbox-line' },
      { step: '04', title: '进行试验', description: '使用专业设备进行精密试验', icon: 'ri-flask-line' },
      { step: '05', title: '结果发行', description: '发行试验成绩书并交付', icon: 'ri-file-text-line' }
    ],
    categories: [
      {
        id: 'jewelry',
        name: '珠宝',
        description: '验证贵金属及宝石类的品质和安全性',
        tests: [
          { category: '成分分析', items: ['贵金属纯度分析', '合金成分分析', '镀层厚度测量', '宝石鉴定'] },
          { category: '有害物质检查', items: ['铅(Pb)', '镉(Cd)', '镍溶出', '6价铬'] },
          { category: '物理试验', items: ['耐磨性', '耐腐蚀性', '镀层附着力', '拉伸强度'] }
        ],
        standards: ['US CPSC/CPSIA', 'US State Law', 'EU REACH', 'GB', 'KC', 'SAH认证规格', '925 Silver', '贵金属Labeling规定']
      },
      {
        id: 'children',
        name: '儿童用品',
        description: '彻底检查儿童产品的安全性和品质',
        tests: [
          { category: '物理安全性', items: ['小部件', '尖锐末端', '跌落试验', '压缩试验', '拉伸试验', '扭转试验'] },
          { category: '化学安全性', items: ['重金属8种', '邻苯二甲酸盐6种', '偶氮染料', 'BPA', '甲醛'] },
          { category: '可燃性试验', items: ['纤维可燃性', '塑料可燃性'] }
        ],
        standards: ['ASTM F963', 'EN 71', 'GB 6675', 'CPSIA', 'ISO 8124']
      },
      {
        id: 'baby',
        name: '婴幼儿用品',
        description: '优先验证婴幼儿产品的安全性',
        tests: [
          { category: '物理安全性', items: ['窒息危险', '尖锐部分', '夹伤危险', '稳定性试验'] },
          { category: '化学安全性', items: ['重金属', '邻苯二甲酸盐', 'BPA', '甲醛', 'VOCs'] },
          { category: '微生物试验', items: ['总需氧菌数', '大肠菌群', '金黄色葡萄球菌', '绿脓杆菌'] }
        ],
        standards: ['ASTM F2194', 'EN 14372', 'GB 28482', 'CPSIA', 'FDA']
      },
      {
        id: 'stationery',
        name: '文具用品',
        description: '评价学生用文具类的安全性和品质',
        tests: [
          { category: '化学安全性', items: ['重金属8种', '芳香胺', '邻苯二甲酸盐', '甲醛'] },
          { category: '物理安全性', items: ['尖锐末端', '笔帽安全性', '笔尖安全性'] },
          { category: '性能试验', items: ['书写性能', '橡皮性能', '粘着力', '耐水性'] }
        ],
        standards: ['EN 71-3', 'ASTM D4236', 'GB 21027', 'ISO 11540']
      },
      {
        id: 'hygiene',
        name: '卫生用品',
        description: '验证卫生用品的安全性和功效',
        tests: [
          { category: '微生物试验', items: ['总需氧菌数', '大肠杆菌', '绿脓杆菌', '金黄色葡萄球菌', '霉菌'] },
          { category: '化学安全性', items: ['重金属', '甲醇', '甲醛', '防腐剂', 'pH'] },
          { category: '功效试验', items: ['抗菌效果', '杀菌效果', '清洁力'] }
        ],
        standards: ['GB 15979', 'ISO 22196', 'ASTM E2149', 'FDA']
      },
      {
        id: 'safety',
        name: '安全用品',
        description: '评价个人保护设备的安全性和性能',
        tests: [
          { category: '物理性能', items: ['冲击吸收', '穿透阻力', '拉伸强度', '耐磨性'] },
          { category: '化学安全性', items: ['有害物质', 'pH', '皮肤刺激性'] },
          { category: '功能性试验', items: ['防水性', '透气性', '阻燃性', '耐热性'] }
        ],
        standards: ['EN 420', 'ANSI Z87.1', 'EN 388', 'ISO 20345', 'GB 2626']
      },
      {
        id: 'textile',
        name: '纤维用品',
        description: '综合评价纤维产品的品质和安全性',
        tests: [
          { category: '化学安全性', items: ['偶氮染料', '甲醛', 'pH', '重金属', '过敏染料', 'DMFu'] },
          { category: '物理性能', items: ['拉伸强度', '撕裂强度', '耐磨性', '起球试验', '尺寸变化率'] },
          { category: '功能性试验', items: ['洗涤牢度', '汗渍牢度', '摩擦牢度', '日晒牢度', '防水性', '透气性'] },
          { category: '可燃性试验', items: ['纤维可燃性', '阻燃性评价'] }
        ],
        standards: ['OEKO-TEX Standard 100', 'GB 18401', 'REACH', 'CPSIA', 'EN 14682', 'ASTM D4966', 'ISO 105']
      },
      {
        id: 'electrical',
        name: '家用电器产品',
        description: '验证家电产品的电气安全性和性能',
        tests: [
          { category: '电气安全性', items: ['绝缘电阻', '耐电压', '接地连续性', '泄漏电流', '温升'] },
          { category: '机械安全性', items: ['结构检查', '机械强度', '稳定性试验', '跌落试验'] },
          { category: '化学安全性', items: ['有害物质(RoHS)', '阻燃性', 'PAHs', '邻苯二甲酸盐'] },
          { category: 'EMC试验', items: ['电磁兼容性', '电磁发射', '电磁抗扰度'] }
        ],
        standards: ['IEC 60335', 'GB 4706', 'UL 1026', 'EN 60335', 'KC认证', 'CE认证', 'RoHS', 'REACH']
      },
      {
        id: 'game',
        name: '游戏',
        description: '评价游戏产品的安全性和品质',
        tests: [
          { category: '物理安全性', items: ['小部件', '尖锐末端', '跌落试验', '压缩试验'] },
          { category: '化学安全性', items: ['重金属', '邻苯二甲酸盐', 'PAHs', '偶氮染料'] }
        ],
        standards: ['ASTM F963', 'EN 71', 'GB 6675', 'CPSIA']
      },
      {
        id: 'silver',
        name: 'Silver用品',
        description: '验证Silver产品的纯度和品质',
        tests: [
          { category: '成分分析', items: ['Silver纯度分析', '合金成分分析', '镀层分析'] },
          { category: '有害物质检查', items: ['铅(Pb)', '镉(Cd)', '镍溶出', '重金属'] },
          { category: '物理试验', items: ['耐磨性', '耐腐蚀性', '镀层附着力'] }
        ],
        standards: ['925 Silver', 'US CPSC', 'EU REACH', 'GB', 'KC']
      },
      {
        id: 'furniture',
        name: '室内家具产品',
        description: '评价室内家具的安全性和耐久性',
        tests: [
          { category: '物理安全性', items: ['稳定性试验', '耐久性试验', '跌落试验', '载荷试验'] },
          { category: '化学安全性', items: ['甲醛', 'VOCs', '重金属', '阻燃性'] },
          { category: '材料试验', items: ['木材强度', '粘合剂性能', '表面处理', '耐磨性'] }
        ],
        standards: ['EN 12520', 'BIFMA', 'GB 28007', 'CARB', 'REACH']
      },
      {
        id: 'packaging',
        name: '包装物(内外包装)',
        description: '验证包装材料的安全性和性能',
        tests: [
          { category: '物理试验', items: ['压缩强度', '跌落试验', '振动试验', '冲击试验'] },
          { category: '化学安全性', items: ['重金属', '邻苯二甲酸盐', 'PAHs', '食品接触物质'] },
          { category: '性能试验', items: ['防水性', '耐热性', '密封性能', '印刷品质'] }
        ],
        standards: ['ISTA', 'ASTM D4169', 'ISO 12048', 'GB/T 4857', 'FDA', 'EU 10/2011']
      }
    ]
  },

  // Certification Page
  certification: {
    badge: '主要业务',
    title: '认证业务/认证标志',
    subtitle: '支持为进入全球市场而获取各国的必备认证及认证标志。提供CCC、CE、FCC、UL等多种国际认证服务。',
    backToHome: '返回首页',
    companyName: '青岛思提尔检测技术服务有限公司',
    servicesTitle: '主要认证服务',
    servicesSubtitle: '提供符合各国限制要求事项的认证服务',
    benefitsTitle: '认证的优点',
    benefitsSubtitle: '通过国际认证可获得的各种好处',
    processTitle: '认证进行流程',
    processSubtitle: '通过系统化认证程序支持快速准确的认证获取',
    ctaTitle: '需要认证咨询吗？',
    ctaDesc: '专业咨询师将为您的产品提供最优化的认证方法指导。',
    ctaButton1: '在线咨询',
    ctaButton2: '电话咨询',
    ctaPhone: '电话咨询',
    ctaPhoneNumber: '0532-55566163/55566165',
    viewDetails: '查看详细',
    processingPeriod: '处理期间',
    validityPeriod: '有效期',
    applicableProducts: '适用产品',
    certificationProcess: '认证程序',
    benefits: [
      { title: '全球市场进入', description: '通过各国的认证可在全球市场出口产品', icon: 'ri-global-line' },
      { title: '产品可靠性提高', description: '国际认证标志保证产品的品质和安全性', icon: 'ri-shield-check-line' },
      { title: '竞争力强化', description: '通过认证可在市场获得竞争优势', icon: 'ri-line-chart-line' },
      { title: '专业咨询', description: '提供认证全过程的专业咨询', icon: 'ri-customer-service-line' }
    ],
    processSteps: [
      { step: '01', title: '咨询及报价', description: '确认产品及认证要求事项', icon: 'ri-customer-service-line' },
      { step: '02', title: '合同及申请', description: '签订认证合同并提交申请书', icon: 'ri-file-text-line' },
      { step: '03', title: '进行试验', description: '产品样品试验及评价', icon: 'ri-flask-line' },
      { step: '04', title: '工厂审查', description: '生产工厂现场审查（必要时）', icon: 'ri-building-line' },
      { step: '05', title: '证书发行', description: '发行证书并批准标志使用', icon: 'ri-award-line' }
    ],
    certifications: [
      {
        id: 'ccc',
        name: 'CCC认证',
        fullName: 'China Compulsory Certification',
        country: '中国',
        description: 'System认证',
        products: ['电气电子产品', '汽车零部件', '安全玻璃', '消防产品', '无线通信设备', '信息技术设备'],
        process: ['申请书提交及合同', '产品样品试验', '工厂审查', '证书发行', '事后管理'],
        period: '60-90天',
        validity: '5年'
      },
      {
        id: 'ce',
        name: 'CE标志',
        fullName: 'Conformité Européenne',
        country: '欧盟',
        description: 'SAH安全卫生标志',
        products: ['电气电子产品', '机械类', '医疗器械', '玩具', '个人防护设备', '建筑材料'],
        process: ['适用指令确认', '符合性评价', '技术文件编写', 'CE标志粘贴', '符合性声明书编写'],
        period: '30-60天',
        validity: '产品变更时为止'
      },
      {
        id: 'fcc',
        name: 'FCC认证',
        fullName: 'Federal Communications Commission',
        country: '美国',
        description: '质量保证标志',
        products: ['无线通信设备', '计算机及周边设备', '家电产品', 'LED照明', '工业用电子设备'],
        process: ['产品分类确认', 'EMC试验', '证书申请', 'FCC ID发行', '标签粘贴'],
        period: '20-40天',
        validity: '永久'
      },
      {
        id: 'system',
        name: 'System认证',
        fullName: 'Management System Certification',
        country: '国际',
        description: 'HSPM、汽车、社会责任SA8000、ISO 9000/ISO 14000',
        products: ['HSPM（危害要素重点管理）', '汽车产业', 'SA8000（社会责任）', 'ISO 9000（质量管理）', 'ISO 14000（环境管理）', '综合经营系统'],
        process: ['经营系统构建', '文件化作业', '内部审查', '认证审查', '证书发行'],
        period: '90-120天',
        validity: '3年（年度事后审查）'
      },
      {
        id: 'sah',
        name: 'SAH安全卫生标志',
        fullName: 'Safety And Hygiene Mark',
        country: '国际',
        description: '珠宝/贵金属/宝石类、日用品、Silver用品、卫生用品、个人安全保护器具',
        products: ['珠宝/贵金属/宝石类', '日用品', 'Silver用品', '卫生用品', '个人安全保护器具', '生活用品'],
        process: ['产品安全性评价', '卫生试验', '有害物质检查', '质量验证', '证书发行'],
        period: '30-60天',
        validity: '2年'
      },
      {
        id: 'quality',
        name: '质量保证标志',
        fullName: 'Quality Assurance Mark',
        country: '国际',
        description: '贵金属/宝石类质量保证',
        products: ['贵金属产品', '宝石类', '钻石', '金/银产品', '珍珠', '高级珠宝'],
        process: ['成分分析', '质量检查', '纯度测量', '鉴定书发行', '质量保证书发行'],
        period: '15-30天',
        validity: '永久'
      },
      {
        id: 'ul',
        name: 'UL认证',
        fullName: 'Underwriters Laboratories',
        country: '美国',
        description: '美国的产品安全认证机构，全球认可的安全标志。',
        products: ['电气电子产品', '火灾安全产品', '工业用设备', '医疗器械', '建筑材料', '家电产品'],
        process: ['产品评价申请', '样品试验', '工厂审查', 'UL标志批准', '定期工厂审查'],
        period: '60-90天',
        validity: '年度更新'
      },
      {
        id: 'rohs',
        name: 'RoHS认证',
        fullName: 'Restriction of Hazardous Substances',
        country: '欧盟',
        description: '电气电子产品中有害物质使用限制指令。',
        products: ['电气电子产品', '家电产品', '照明设备', '玩具', '医疗器械', '监控设备'],
        process: ['产品分析', '有害物质试验', '符合性评价', '证书发行', '技术文件编写'],
        period: '15-30天',
        validity: '产品变更时为止'
      },
      {
        id: 'reach',
        name: 'REACH认证',
        fullName: 'Registration, Evaluation, Authorization of Chemicals',
        country: '欧盟',
        description: 'EU关于化学物质注册、评价、许可及限制的规定。',
        products: ['化学物质', '纤维产品', '电气电子产品', '玩具', '家具', '包装材料'],
        process: ['SVHC确认', '化学物质分析', '符合性评价', '报告编写', '证书发行'],
        period: '20-40天',
        validity: '1年'
      },
      {
        id: 'cpsia',
        name: 'CPSIA认证',
        fullName: 'Consumer Product Safety Improvement Act',
        country: '美国',
        description: '美国消费者产品安全改进法，儿童产品的安全标准。',
        products: ['儿童玩具', '婴幼儿用品', '儿童服装', '学习用品', '儿童家具', '儿童配饰'],
        process: ['产品试验', '铅含量检查', '邻苯二甲酸盐检查', 'CPC证书编写', '标签粘贴'],
        period: '15-30天',
        validity: '产品变更时为止'
      },
      {
        id: 'astm',
        name: 'ASTM F963',
        fullName: 'American Society for Testing and Materials',
        country: '美国',
        description: '美国玩具安全标准，评价玩具的物理、化学安全性。',
        products: ['玩具', '游戏', '拼图', '玩偶', '体育玩具', '教育玩具'],
        process: ['物理试验', '化学试验', '可燃性试验', '符合性评价', '证书发行'],
        period: '20-40天',
        validity: '产品变更时为止'
      }
    ]
  },

  // Certification Support Page
  certificationSupport: {
    badge: '客户支持',
    title: '认证制度支持(按领域)',
    subtitle: '为各领域国内外认证制度提供专业咨询和试验服务',
    backToHome: '返回首页',
    processTitle: '认证支持流程',
    processSubtitle: '通过系统化流程支持认证获取',
    ctaTitle: '有认证相关咨询吗？',
    ctaDesc: '专业咨询师将为您指导贵公司产品所需的认证',
    ctaButton: '咨询联系',
    processSteps: [
      { step: '1', title: '咨询及分析', desc: '产品及认证要求事项分析', icon: 'ri-discuss-line' },
      { step: '2', title: '试验计划', desc: '建立所需试验项目及日程', icon: 'ri-file-list-line' },
      { step: '3', title: '进行试验', desc: '按国际标准进行精密试验', icon: 'ri-test-tube-line' },
      { step: '4', title: '报告发行', desc: '编写试验结果报告', icon: 'ri-file-text-line' },
      { step: '5', title: '认证支持', desc: '向认证机构提交及事后管理', icon: 'ri-award-line' }
    ],
    certifications: {
      children: {
        title: '儿童/婴幼儿用品认证',
        description: '保证儿童和婴幼儿安全的国内外认证支持',
        standards: [
          { name: 'KC认证', desc: '韩国儿童产品安全特别法认证' },
          { name: 'EN 71', desc: '欧洲玩具安全规格' },
          { name: 'ASTM F963', desc: '美国玩具安全规格' },
          { name: 'CPSIA', desc: '美国消费者产品安全改进法' },
          { name: 'GB 6675', desc: '中国玩具安全技术规范' }
        ]
      },
      jewelry: {
        title: '珠宝认证',
        description: '保证贵金属及宝石类品质和安全性的认证',
        standards: [
          { name: 'KC认证', desc: '韩国贵金属及宝石类品质认证' },
          { name: 'REACH', desc: '欧洲化学物质管制' },
          { name: 'RoHS', desc: '有害物质使用限制指令' },
          { name: 'California Prop 65', desc: '加利福尼亚有害物质警告规定' },
          { name: 'Nickel Release', desc: '镍溶出试验' }
        ]
      },
      textile: {
        title: '纤维/服装认证',
        description: '认证纤维产品安全性和品质的国际标准',
        standards: [
          { name: 'Oeko-Tex Standard 100', desc: '有害物质检查认证' },
          { name: 'GOTS', desc: '有机纤维国际认证' },
          { name: 'REACH', desc: '欧洲化学物质管制' },
          { name: 'KC认证', desc: '韩国纤维产品品质认证' },
          { name: 'CPSIA', desc: '美国消费者产品安全法' }
        ]
      },
      cosmetics: {
        title: '化妆品认证',
        description: '验证化妆品安全性和功效的认证制度',
        standards: [
          { name: 'ISO 22716', desc: '化妆品GMP国际标准' },
          { name: 'CPNP', desc: '欧洲化妆品申报门户' },
          { name: 'FDA注册', desc: '美国食品药品监督管理局注册' },
          { name: 'CFDA', desc: '中国食品药品监督管理总局认证' },
          { name: 'KC认证', desc: '韩国化妆品安全标准' }
        ]
      },
      food: {
        title: '食品认证',
        description: '保证食品安全性和品质的认证系统',
        standards: [
          { name: 'HACCP', desc: '食品安全管理认证' },
          { name: 'ISO 22000', desc: '食品安全经营系统' },
          { name: 'FSSC 22000', desc: '食品安全系统认证' },
          { name: 'Halal', desc: '清真认证' },
          { name: 'Kosher', desc: '犹太认证' }
        ]
      },
      electronics: {
        title: '电子/电气认证',
        description: '验证电子产品安全性和性能的国际认证',
        standards: [
          { name: 'CE标志', desc: '欧洲产品安全认证' },
          { name: 'FCC', desc: '美国联邦通信委员会认证' },
          { name: 'RoHS', desc: '有害物质使用限制指令' },
          { name: 'REACH', desc: '欧洲化学物质管制' },
          { name: 'KC认证', desc: '韩国电子产品安全认证' }
        ]
      },
      medical: {
        title: '医疗器械认证',
        description: '保证医疗器械安全性和功效的认证',
        standards: [
          { name: 'ISO 13485', desc: '医疗器械品质经营系统' },
          { name: 'CE标志 (MDR)', desc: '欧洲医疗器械规定' },
          { name: 'FDA 510(k)', desc: '美国医疗器械上市前申报' },
          { name: 'MFDS认证', desc: '韩国食品药品安全处认证' },
          { name: 'CFDA', desc: '中国医疗器械注册' }
        ]
      },
      environmental: {
        title: '环境认证',
        description: '认证环保产品的国际标准',
        standards: [
          { name: 'ISO 14001', desc: '环境经营系统认证' },
          { name: 'Carbon Footprint', desc: '碳足迹认证' },
          { name: 'FSC', desc: '森林管理委员会认证' },
          { name: 'Energy Star', desc: '能源效率认证' },
          { name: '环境标志', desc: '韩国环境标志认证' }
        ]
      }
    },
    standardsTitle: '主要认证标准'
  }
};
